// Navigation config for the Service Desk agent workspace. Single source of
// truth for the sub-menu (ServiceDeskLayout) and the routes (routes.tsx).
export const SERVICE_DESK_BASE = "/service-desk";

export interface SdMenuItem {
  id: string;
  label: string;
  icon: string; // remixicon class
}

export const SD_MENU: SdMenuItem[] = [
  { id: "dashboard", label: "Dashboard", icon: "ri-dashboard-line" },
  { id: "kanban", label: "Tablero Kanban", icon: "ri-layout-column-line" },
  { id: "tickets", label: "Tickets", icon: "ri-ticket-2-line" },
  { id: "slas", label: "SLAs", icon: "ri-timer-flash-line" },
  // Registro y presencia de los runners de código (#511).
  { id: "agents", label: "Agentes", icon: "ri-robot-2-line" },
  { id: "settings", label: "Configuración", icon: "ri-settings-3-line" },
];

export const serviceDeskDefaultRoute = `${SERVICE_DESK_BASE}/dashboard`;
